import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import HomeLanding from "../views/HomeLanding";

export default function Home(props) {

  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  async function init() {
    const nextView = getView();
    if (nextView) {
      setView(nextView);
    }
  }

  function getView() {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <HomeLanding />
    }

    return null;
  }

  useEffect(() => {
    init();
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem])

  return view;
}
